import { marked } from 'marked'
import DOMPurify from 'dompurify'

// Render markdown links so they open in a new tab (with noopener for safety).
const renderer = new marked.Renderer()
const baseLink = renderer.link.bind(renderer)
renderer.link = (href, title, text) =>
  baseLink(href, title, text).replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ')

/**
 * Parse markdown to sanitized HTML. Links open in a new tab. Returns '' for empty
 * input. Variables in the source are expected to be resolved before this point.
 * @param {string} md
 * @returns {string} sanitized HTML
 */
export function renderMarkdown (md) {
  if (!md) return ''
  return DOMPurify.sanitize(marked.parse(md, { renderer }), { ADD_ATTR: ['target'] })
}
